const withResponsiveLayout = (width, layouts = {}) => {
    if (width >= 0 && width < 768) {
        return layouts.mobile;
    } else if (width >= 768 && width < 1440) {
        return layouts.tablet;
    } else {
        return layouts.desktop;
    }
};

export default withResponsiveLayout;
